<template>
  <span class="svg-container-in" @click="toggleClick">
      <FontIcon type='element-icons' name='el-icon-d-arrow-right' class='icon svg-icon-transform' size='medium' :class="isActive ? 'isActive' : '' "/>
  </span>
</template>

<script>
import FontIcon from '@/components/FontIcon'

export default {
  name: 'Hamburger',
  components: { FontIcon },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
/*
.svg-container {
  vertical-align: middle;
  display: inline;
}

.svg-icon-transform {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
} */

.svg-container-in {
  margin-left: 15px !important;
}

.svg-icon-transform.isActive {
  transform: rotate(180deg);
}
</style>
